export const lists_Load_Vehicles = [
    {
        "name": "Brandweer",
        "key": "fire",
        "vehicle_category": "Brandweer",
        "table": "Rood"
    },
    {
        "name": "Ambulance",
        "key": "ambu",
        "vehicle_category": "Ambulance",
        "table": "Geel"
    },
    {
        "name": "Politie",
        "key": "police",
        "vehicle_category": "Politie",
        "table": "Blauw"
    },
    {
        "name": "Kustwacht / Waterredding",
        "key": "waterrescue",
        "vehicle_category": "Kustwacht",
        "table": "Oranje"
    },
    {
        "name": "Rijkswaterstaat",
        "key": "traffic",
        "vehicle_category": "RWS",
        "table": "Geel"
    }
]
